import type { Effect, Reducer, Subscription } from '@umijs/max';
import { getUserPage } from './service';

type UserListModelType = {
  namespace: 'userList';
  state: API.UserListState;
  effects: {
    fetchUserPageEffect: Effect;
    refreshDataEffect: Effect;
  };
  reducers: {
    setPageData: Reducer<API.UserListState>;
  };
  subscriptions: {
    setup: Subscription;
  };
};

const UserListModel: UserListModelType = {
  namespace: 'userList',

  state: {
    items: [],
    total: 0,
    current: 1,
    pageSize: 20,
  },

  effects: {
    fetchUserPageEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getUserPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },

    refreshDataEffect: function* ({ payload }, { call, put }) {
      const res = yield call(getUserPage, payload);
      if (res.code === 0) {
        yield put({
          type: 'setPageData',
          payload: {
            items: res.data.items,
            total: res.data.total,
            current: res.data.current,
            pageSize: res.data.pageSize,
          },
        });
      }
    },
  },

  reducers: {
    setPageData(state, action) {
      return {
        ...state,
        ...action.payload,
      };
    },
  },

  subscriptions: {
    setup({ dispatch, history }) {
      return history.listen(({ pathname }) => {
        if (pathname === '/userManage/userList') {
          // 页面初始化时不自动加载数据，由组件控制
        }
      });
    },
  },
};

export default UserListModel;
